<div
     appBadgeScanner
     [isScanListenerActive]="isScanListenerActive"
     (scan)="onToolEngravedCodeScan($event)"></div>
<div class="title">{{'admin.tools.engrave.message' | translate}}</div>
<div class="scanner-status">
    <label>Status:</label>
    <span *ngIf="focused"
          class="message ok">{{'admin.tools.engrave.waiting' | translate}}</span>
    <span *ngIf="!focused"
          class="message not-ok">{{'admin.tools.engrave.outOfFocus' | translate}}</span>
</div>
<div class="list">
    <div class="list-header">
        <div class="tool-engrave-status">
            <i class="material-icons"
               *ngIf="!allToolsEngraved">check_box_outline_blank</i>
            <i class="material-icons"
               *ngIf="allToolsEngraved">check_box</i>
        </div>
        <div class="tool-name">{{'admin.tools.engrave.toolName' | translate}}</div>
    </div>
    <ul class="list-content">
        <li *ngFor="let tool of toolsToScan"
            class="list-item"
            [class.is-engraved]="tool.isEngraved">
            <div class="tool-engrave-status">
                <i class="material-icons"
                   *ngIf="!tool.isEngraved">check_box_outline_blank</i>
                <i class="material-icons"
                   *ngIf="tool.isEngraved">check_box</i>
            </div>
            <div class="tool-name">{{tool.toolName}}</div>
            <div class="confirmation"
                 *ngIf="tool.isEngraved">{{'admin.tools.engrave.complete' | translate}}</div>
            <div class="confirmation"
                 *ngIf="!tool.isEngraved">{{tool.engravedCode}}</div>
        </li>
    </ul>
</div>
